import React from "react";
import AddDevicePage from "./views/AddDevicePage";
import { AddDeviceContextProvider } from "./AddDeviceView";
import AddDeviceContent from "../../constants/contentFile.json";
const AddDevice = () => {
  return (
    <AddDeviceContextProvider>
      <AddDevicePage textContants={AddDeviceContent.pageAddDevice} />
    </AddDeviceContextProvider>
  );
};
export default AddDevice;
